import type {RouteParamValue} from "vue-router";
import {normalizeLocale} from "@/shared/lib/i18n";
import {setGlobalLocale} from "@/app/providers/i18n";

/**
 * Язык из сегмента пути. При обычном заходе по ссылке его уже применил i18n-провайдер
 * (он читает location при старте), это нужно для переходов внутри SPA.
 * Cookie намеренно не трогаем: язык из URL — разовый, предпочтение пользователя не меняет.
 */
export function applyUrlLocale(param: RouteParamValue | RouteParamValue[] | undefined): void {
    const locale = normalizeLocale(Array.isArray(param) ? param[0] : param);
    if (locale) {
        setGlobalLocale(locale);
    }
}
